import { useSearchParams } from 'react-router'

export default function useSearchQuery () {
  const [ searchParams ] = useSearchParams()

  return searchParams.get('query') || ''
}
